/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from 'react';
import { LocalStorageAdapter } from 'PlugAndPlay/_data-layer/js/Adapters/StorageAdapters/LocalStorageAdapter/LocalStorageAdapter';
import { DatastoreBookmarkAdapter } from 'PlugAndPlay/_data-layer/js/Adapters/BookmarkAdapters/DatastoreBookmarkAdapter/DatastoreBookmarkAdapter';

// Lazy load the main Bookmarks 'app'
const Bookmarks = React.lazy(() =>
    import(/* webpackChunkName: "Bookmarks" */ './bookmarks')
);

const appWrapper = document.querySelectorAll('[data-component="bookmarks"]');
// Don't run if wrapper doesn't exist
if (appWrapper.length > 0) {
    // Only load ReactDOM from if its needed as its pretty large
    import(/* webpackChunkName: "ReactDOM" */ 'react-dom').then((ReactDOM) => {
        appWrapper.forEach((wrapper) => {
            let bookmarkAdapter;
            const { dataset } = wrapper;
            const bookmarksConfiguration = JSON.parse(
                dataset.bookmarksConfiguration
            );

            if (bookmarksConfiguration.datasource === 'datastore') {
                const datastore = new Datastore({
                    serviceURL: bookmarksConfiguration.datasourceUrl,
                    jwtURL: bookmarksConfiguration.datasourceJWT,
                });

                bookmarkAdapter = new DatastoreBookmarkAdapter({ datastore });
            }

            if (bookmarksConfiguration.datasource === 'localstorage') {
                bookmarkAdapter = new LocalStorageAdapter({
                    storageKey: bookmarksConfiguration.documentId,
                });
            }

            ReactDOM.render(
                <Suspense
                    fallback={
                        <div className="bookmarks__skeleton">Loading...</div>
                    }
                >
                    {bookmarkAdapter ? (
                        <Bookmarks
                            {...bookmarksConfiguration}
                            bookmarkAdapter={bookmarkAdapter}
                        />
                    ) : (
                        <>
                            Adapter is not provided, please pass
                            datasource:datastore|localstorage into your
                            component configuration
                        </>
                    )}
                </Suspense>,
                wrapper
            );
        });
    });
}
